import { render, staticRenderFns } from "./CanvaMap2.vue?vue&type=template&id=17a5cd7a&scoped=true&"
import script from "./CanvaMap2.vue?vue&type=script&lang=js&"
export * from "./CanvaMap2.vue?vue&type=script&lang=js&"
import style0 from "./CanvaMap2.vue?vue&type=style&index=0&id=17a5cd7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a5cd7a",
  null
  
)

export default component.exports